import * as React from "react";
import BaseComponent from "src/engine/ui/BaseComponent";
import { ClickType, sourceMap } from "../const";
import { getRole } from "../../service";
import { Toast } from "antd-mobile";
import "./index.scss";

interface IProps {
    clickBtn: string;
    onClose: () => void;
    onOpenCheck: (userType: string) => void;
    changeRoleId: (roleId: string) => void;
}

interface IState {
    loading: boolean;
    roleId: string;
}

// 角色弹窗
class RoleModal extends BaseComponent<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        this.state = {
            loading: false,
            roleId: "",
        };
    }

    /**修改角色 */
    onChangeRoleId = (e: any) => {
        let roleId = e.target.value;
        this.setState({
            roleId,
        });
    };

    onGetRoleInfo = () => {
        const { onClose, onOpenCheck, changeRoleId } = this.props;
        const { loading, roleId } = this.state;
        if (!roleId) {
            Toast.show("请输入角色编号", 3, false);
            return;
        }
        if (roleId?.length < 11 || roleId?.length > 16) {
            Toast.show("角色编号错误", 3, false);
            return;
        }
        if (loading) return;
        this.setState({
            loading: true,
        });
        getRole(roleId).then((res: any) => {
            this.setState({
                loading: false,
            });
            const { code, rev, msg, data } = res || {};
            if (code === 0 && rev == true) {
                const source = data ? data + "" : "";
                changeRoleId(roleId);
                onOpenCheck(sourceMap[source]);
                onClose();
            } else {
                const textMAp = {
                    401: "输入太频繁,请5s后重新输入",
                    402: "您已达次数上限，请明日再来",
                    403: "输入太频繁,请5s后重新输入",
                    404: "您已达次数上限，请明日再来",
                    1: "角色ID不存在，请5s后重新输入",
                };
                const text = textMAp[code || ""] || "获取角色失败";
                onClose();
                Toast.show(text, 3, true);
            }
        });
    };

    render() {
        const { clickBtn, onClose } = this.props;
        const { roleId } = this.state;

        return (
            <div className="role-modal">
                <div className={clickBtn === ClickType.XX ? "role-content special" : "role-content"}>
                    <div className="btn-close" onClick={onClose}></div>
                    <div className="role-box">
                        <div className="role-pic"></div>
                        <div className="role-pic-des">如何获得您的角色编号</div>
                        <div className="role-title">请输入您的角色编号：</div>
                        <div className="input-role">
                            <input
                                type="text"
                                // maxLength={11}
                                autoComplete="off"
                                placeholder="请输入角色编号"
                                value={roleId}
                                onChange={(e) => this.onChangeRoleId(e)}
                            />
                        </div>
                        <div className="role-tips">温馨提示：同一个账号下只能有一个角色领取皮肤</div>
                        <div className="btn-submit" onClick={this.onGetRoleInfo}></div>
                    </div>
                </div>
            </div>
        );
    }
}

export default RoleModal;
